// extracted by mini-css-extract-plugin
export default {"row":"title_row__Y2EKC","name":"title_name__ZGk7j","created":"title_created__VFJl4"};